<template>
    <div class="reminder-message-page">
        <!-- 页面头部 -->
        <div class="reminder-message-page__header">
            <div class="reminder-message-page__header-left">
                <div class="reminder-message-page__title">提醒消息</div>
                <div class="reminder-message-page__subtitle">共 {{ total }} 条记录</div>
            </div>
        </div>

        <!-- 内容卡片 -->
        <div class="reminder-message-content-card">
            <!-- 筛选区域 -->
            <div class="reminder-message-section reminder-message-section--filter">
                <div class="reminder-message-section__title">筛选条件</div>
                <div class="reminder-message-filter-row">
                    <div class="reminder-message-filter-item">
                        <label class="reminder-message-filter-label">通知标题</label>
                        <div class="reminder-message-search-field">
                            <i class="el-icon-search reminder-message-search-field__icon"></i>
                            <input
                                v-model="listQuery.Title"
                                placeholder="搜索标题"
                                class="reminder-message-search-field__input"
                                @keyup.enter="getList"
                            />
                        </div>
                    </div>
                    <div class="reminder-message-filter-item reminder-message-filter-item--actions">
                        <button class="reminder-message-search-btn reminder-message-search-btn--ghost" @click="reset">重置</button>
                        <button class="reminder-message-search-btn" @click="getList">查找</button>
                    </div>
                </div>
                <div class="reminder-message-chips">
                    <button
                        v-for="chip in categoryChips"
                        :key="chip.value"
                        class="reminder-message-chip"
                        :class="{ 'reminder-message-chip--active': activeCategory === chip.value }"
                        @click="switchCategory(chip.value)"
                    >
                        {{ chip.label }}
                    </button>
                </div>
            </div>

            <!-- 表格区域 -->
            <div class="reminder-message-section reminder-message-section--report">
                <div class="reminder-message-section__title">消息列表</div>

                <div class="reminder-message-table-wrap tableAuto">
                    <div class="tableAutoMain">
                        <el-table
                            ref="Table1"
                            :data="KhList"
                            style="width: 100%"
                            height="calc(100% - 0.1rem)"
                            v-if="KhList.length > 0"
                            @row-click="onRowClick"
                            :row-class-name="tableRowClassName"
                        >
                            <el-table-column align="left" show-overflow-tooltip label="创建人" width="100" fixed>
                                <template slot-scope="scope">
                                    <div class="reminder-message-member-cell">
                                        <span class="reminder-message-avatar-icon" :style="{ background: getAvatarColor(getUserName(scope.row.CreateUserName)) }">
                                            {{ getUserName(scope.row.CreateUserName) ? getUserName(scope.row.CreateUserName).charAt(0).toUpperCase() : '?' }}
                                        </span>
                                        <span class="reminder-message-member-name">{{ getUserName(scope.row.CreateUserName) }}</span>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="是否已读" width="90">
                                <template slot-scope="scope">
                                    <span
                                        class="reminder-message-status-badge"
                                        :class="scope.row.IsRead ? 'reminder-message-status-badge--green' : 'reminder-message-status-badge--red'"
                                    >
                                        {{ scope.row.IsRead ? '已读' : '未读' }}
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="标题" width="130">
                                <template slot-scope="scope">{{ scope.row.Title }}</template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="提醒内容" min-width="220">
                                <template slot-scope="scope">{{ scope.row.DetailInfo | setCompanyName }}</template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="通知类型" width="110">
                                <template slot-scope="scope">
                                    <span class="reminder-message-type-badge" :style="{ background: noticeTypeColor(scope.row.NoticeType) }">{{ scope.row.NoticeType | setNoticeType }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="联系人" min-width="150">
                                <template slot-scope="scope">
                                    <!-- 有 CustomerId 的行整行可点（row-click），这里只负责蓝色可点的外观 -->
                                    <span v-if="hasCustomer(scope.row)" class="reminder-message-contact-link">
                                        <span v-if="scope.row.ContactName">{{ scope.row.ContactName }}</span>
                                        <span v-if="scope.row.ContactName && scope.row.ContactPhone" class="reminder-message-contact-sep">·</span>
                                        <span v-if="scope.row.ContactPhone">{{ scope.row.ContactPhone | setPhoneType }}</span>
                                        <span v-if="!scope.row.ContactName && !scope.row.ContactPhone">查看客户</span>
                                    </span>
                                    <span v-else-if="scope.row.ContactName || scope.row.ContactPhone">
                                        <span v-if="scope.row.ContactName">{{ scope.row.ContactName }}</span>
                                        <span v-if="scope.row.ContactName && scope.row.ContactPhone" class="reminder-message-contact-sep">·</span>
                                        <span v-if="scope.row.ContactPhone">{{ scope.row.ContactPhone | setPhoneType }}</span>
                                    </span>
                                    <span v-else class="reminder-message-contact-empty">——</span>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="创建时间" min-width="170">
                                <template slot-scope="scope">{{ scope.row.CreateTime | formaDate('yyyy-MM-dd hh:mm:ss') }}</template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="提醒时间" min-width="170">
                                <template slot-scope="scope">{{ scope.row.RemindTime | formaDate('yyyy-MM-dd hh:mm:ss') }}</template>
                            </el-table-column>

                            <el-table-column align="center" label="操作" width="100" fixed="right">
                                <template slot-scope="scope">
                                    <div v-if="!scope.row.IsRead">
                                        <el-tooltip class="item" effect="light" content="标记已读" placement="top">
                                            <i class="reminder-message-action-icon reminder-message-action-icon--blue el-icon-check" @click.stop="handleUpdate(scope.$index, scope.row)"></i>
                                        </el-tooltip>
                                    </div>
                                    <span v-else class="reminder-message-read-text">已读</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div v-else class="reminder-message-empty">
                            <i class="el-icon-message"></i>
                            <p>暂无消息</p>
                        </div>
                    </div>
                </div>

                <!-- 分页 -->
                <div class="reminder-message-pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page.sync="listQuery.PageIndex"
                        :page-size="listQuery.PageSize"
                        :page-sizes="[10, 20, 50]"
                        :total="total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GetNoticePageList, UpdateNoticeRead } from '@/api/NoticeInfo';
import { GetUserList } from '@/api/UserInfo';
import vfilter from '@/utils/vfilter.js';

export default {
    components: {},
    data() {
        return {
            listQuery: {},
            KhList: [],
            total: 0,
            listLoading: true,
            userData: [],
            activeCategory: 'all',
            categoryChips: [
                { label: '全部', value: 'all' },
                { label: '我的提醒', value: 'mine' },
                { label: '公海流转', value: 'public' }
            ]
        };
    },
    created() {
        this.activeCategory = this.normalizeCategory(this.$route.query.category);
        this.listQuery = {
            PageIndex: 1,
            PageSize: 10
        };
        this.applyCategory();
        this.getList();
        this.getUserList();
    },
    watch: {
        // 从顶部铃铛「查看更多」跳进来时本页可能已挂载，created 不会再执行
        '$route.query.category'(val) {
            if (this.$route.path !== '/workMessage/reminderMessage') {
                return;
            }
            this.activeCategory = this.normalizeCategory(val);
            this.listQuery.PageIndex = 1;
            this.applyCategory();
            this.getList();
        }
    },
    methods: {
        normalizeCategory(val) {
            return val === 'mine' || val === 'public' ? val : 'all';
        },
        // 必须走 $set/$delete，直接改 delete 会让已选状态和请求参数不同步
        applyCategory() {
            if (this.activeCategory === 'all') {
                this.$delete(this.listQuery, 'Category');
            } else {
                this.$set(this.listQuery, 'Category', this.activeCategory);
            }
        },
        switchCategory(val) {
            if (this.activeCategory === val) {
                return;
            }
            this.activeCategory = val;
            this.listQuery.PageIndex = 1;
            this.applyCategory();
            this.getList();
        },
        noticeTypeColor(value) {
            return vfilter.getNoticeTypeColor(value);
        },
        getUserList() {
            GetUserList({})
                .then((res) => {
                    if (res.data.ErrorCode == '2000') {
                        this.userData = res.data.Data || [];
                    }
                })
                .catch(() => {});
        },
        getUserName(id) {
            if (!id || !this.userData.length) return '';
            var user = this.userData.find(function(v) {
                return v.Id == id;
            });
            return user ? (user.UserAccount || user.NickName) : '';
        },
        getAvatarColor(name) {
            const colors = ['#007aff', '#34c759', '#ff9500', '#ff3b30', '#af52de', '#5856d6', '#ff2d55', '#64d2ff'];
            let hash = 0;
            for (let i = 0; i < (name || '').length; i++) {
                hash = name.charCodeAt(i) + ((hash << 5) - hash);
            }
            return colors[Math.abs(hash) % colors.length];
        },
        reset() {
            this.activeCategory = 'all';
            this.listQuery = {
                PageIndex: 1,
                PageSize: 10
            };
            this.getList();
        },
        // 只有手工建的提醒带 CustomerId；.NET 老数据没赋值时落库是 0，Java 是 NULL，两者都算"无客户可关联"
        hasCustomer(row) {
            return !!(row.CustomerId && Number(row.CustomerId) > 0);
        },
        openCustomer(row) {
            this.$router.push({
                path: '/Customers/myCustomers',
                query: {
                    CustomerId: String(row.CustomerId),
                    CustomerName: row.ContactName || ''
                }
            });
        },
        onRowClick(row) {
            if (this.hasCustomer(row)) {
                this.openCustomer(row);
            }
        },
        // 只有真能跳的行才给手型，避免点下去没反应被当成卡住
        tableRowClassName({ row }) {
            return this.hasCustomer(row) ? 'reminder-message-row--jump' : '';
        },
        handleUpdate(index, row) {
            this.$confirm('确认标记选中的消息为已读吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let params = { Id: row.Id };
                    UpdateNoticeRead(params)
                        .then((res) => {
                            if (res.data.ErrorCode == '2000') {
                                this.$message.success(res.data.Message);
                                this.getList();
                            } else {
                                this.$message.error(res.data.Message);
                            }
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
        handleSizeChange(val) {
            this.listQuery.PageIndex = 1;
            this.listQuery['PageSize'] = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.PageIndex = val;
            this.getList();
        },
        getList() {
            this.listLoading = true;
            GetNoticePageList(this.listQuery)
                .then((res) => {
                    this.listLoading = false;
                    // 分页出参是 PageResponseInfo，成功码为 1000 而非 2000，判成功率比判码更稳
                    if (res.data.IsSuccess) {
                        this.KhList = res.data.Data || [];
                        this.total = res.data.Total || 0;
                    } else {
                        this.KhList = [];
                        this.total = 0;
                        this.$message.error(res.data.Message || '消息列表加载失败');
                    }
                })
                .catch(() => {
                    this.listLoading = false;
                    this.KhList = [];
                    this.total = 0;
                    this.$message.error('消息列表加载失败');
                });
        }
    }
};
</script>

<style lang="scss" scoped>
/* ===========================
   提醒消息页面 - Apple Mac 风格
   =========================== */
.reminder-message-page {
    background: #f5f5f7;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 16px;
}

/* 页面头部 */
.reminder-message-page__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px 8px;
    flex-shrink: 0;
    background: transparent;
}

.reminder-message-page__header-left {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 8px;
}

.reminder-message-page__title {
    font-size: 20px;
    font-weight: 700;
    color: #1d1d1f;
    line-height: 1.2;
}

.reminder-message-page__subtitle {
    font-size: 11px;
    color: #86868b;
}

/* 白色大卡片 */
.reminder-message-content-card {
    flex: 1;
    min-height: 0;
    margin: 8px 20px 16px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 通用区域 */
.reminder-message-section {
    padding: 0;
}

.reminder-message-section--filter {
    flex-shrink: 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
}

.reminder-message-section--report {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.reminder-message-section__title {
    font-size: 14px;
    font-weight: 600;
    color: #1d1d1f;
    padding: 12px 16px 8px;
}

/* 筛选区域 */
.reminder-message-filter-row {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    padding: 4px 16px 12px;
    flex-wrap: wrap;
}

.reminder-message-filter-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.reminder-message-filter-label {
    font-size: 10px;
    font-weight: 600;
    color: #86868b;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.reminder-message-filter-item--actions {
    flex-direction: row;
    align-items: flex-end;
    gap: 6px;
    padding-top: 16px;
}

.reminder-message-search-field {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 220px;
    height: 34px;
    padding: 0 10px;
    border-radius: 8px;
    background: #f5f5f7;
    border: 1.5px solid transparent;
    transition: border-color 0.15s, background 0.15s;

    &:focus-within {
        background: #fff;
        border-color: #007aff;
        box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.15);
    }

    .reminder-message-search-field__icon {
        font-size: 13px;
        color: #86868b;
        flex-shrink: 0;
    }

    .reminder-message-search-field__input {
        flex: 1;
        border: none;
        background: transparent;
        font-size: 12px;
        color: #1d1d1f;
        outline: none;
        height: 100%;

        &::placeholder {
            color: #86868b;
        }
    }
}

/* 搜索按钮 */
.reminder-message-search-btn {
    padding: 7px 14px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.05);
    color: #3c3c43;
    transition: background 0.15s;
    white-space: nowrap;

    &:hover {
        background: rgba(0, 0, 0, 0.09);
    }

    &--ghost {
        background: rgba(0, 0, 0, 0.05);
        color: #3c3c43;

        &:hover {
            background: rgba(0, 0, 0, 0.09);
        }
    }

    &:last-child {
        background: #007aff;
        color: #fff;

        &:hover {
            background: #0071e3;
        }
    }
}

/* 类别切换 chip */
.reminder-message-chips {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 16px 12px;
    flex-wrap: wrap;
}

.reminder-message-chip {
    padding: 5px 14px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
    color: #3c3c43;
    background: #fff;
    border: 0.5px solid rgba(0, 0, 0, 0.12);
    cursor: pointer;
    transition: background 0.15s, color 0.15s, border-color 0.15s, box-shadow 0.15s;
    white-space: nowrap;

    &:hover {
        background: #f5f5f7;
    }

    &--active {
        background: #007aff;
        border-color: #007aff;
        color: #fff;
        box-shadow: 0 2px 6px rgba(0, 122, 255, 0.28);

        &:hover {
            background: #0071e3;
        }
    }
}

/* 表格区域 */
.reminder-message-table-wrap {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0;
    display: flex;
    flex-direction: column;
    background: #f5f5f7;
}

::v-deep .reminder-message-table-wrap .el-table {
    background: transparent;

    &::before {
        display: none;
    }

    .el-table__header-wrapper {
        background: #f5f5f7 !important;
    }

    .el-table__header tr {
        background: transparent !important;
    }

    thead th {
        background: #f5f5f7 !important;
        color: #86868b;
        font-size: 10px;
        font-weight: 600;
        border: none !important;
        padding: 4px 0;
    }

    thead th .cell {
        background: transparent !important;
        color: #86868b;
        font-size: 10px;
        font-weight: 600;
        border: none !important;
    }

    .el-table__fixed {
        thead th {
            background: #f5f5f7 !important;
        }

        &::before {
            display: none !important;
        }

        tbody td {
            background: #fff !important;
            border-bottom: 8px solid #f5f5f7 !important;
            box-shadow: none !important;
        }
    }

    .el-table__fixed-right {
        thead th {
            background: #f5f5f7 !important;
        }

        &::before {
            display: none !important;
        }

        .el-table__fixed-header-wrapper {
            background: #f5f5f7 !important;
        }

        tbody td {
            background: #fff !important;
            border-bottom: 8px solid #f5f5f7 !important;
            box-shadow: none !important;
        }
    }

    .el-table__fixed-right-patch {
        background: #f5f5f7 !important;
    }

    .el-table__body {
        border-collapse: collapse;
        width: 100% !important;
    }

    tbody tr {
        background: transparent !important;
    }

    tbody td {
        background: #fff !important;
        font-size: 13px;
        color: #1d1d1f;
        padding: 8px 0 !important;
        border-bottom: 8px solid #f5f5f7 !important;
        border-top: none !important;
        border-right: none !important;
        transition: background 0.15s;
    }

    tbody td .cell {
        font-size: 13px;
    }

    tbody tr td:first-child {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
    }

    tbody tr td:last-child {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
    }

    tr:hover td {
        background: #fff !important;
    }
}

/* 用户列 */
.reminder-message-member-cell {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding-left: 4px;
}

.reminder-message-avatar-icon {
    width: 26px;
    height: 26px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
    line-height: 1;
}

.reminder-message-member-name {
    font-size: 12px;
    font-weight: 600;
    color: #1d1d1f;
    line-height: 1.2;
}

/* 状态徽章 */
.reminder-message-status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1px 6px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 500;
    color: #fff;
    line-height: 1.4;
    white-space: nowrap;

    &--green {
        background: #34c759;
    }

    &--red {
        background: #ff3b30;
    }
}

/* 通知类型徽章 */
.reminder-message-type-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1px 6px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 500;
    color: #fff;
    line-height: 1.4;
    white-space: nowrap;
}

/* 联系人列 */
.reminder-message-contact-sep {
    color: #c7c7cc;
    margin: 0 5px;
}

.reminder-message-contact-empty {
    color: #c7c7cc;
}

/* 可跳客户的联系人：沿用本页操作图标的 #007aff，不另立一套蓝 */
.reminder-message-contact-link {
    color: #007aff;
    cursor: pointer;

    .reminder-message-contact-sep {
        color: rgba(0, 122, 255, 0.45);
    }

    &:hover {
        text-decoration: underline;
    }
}

/* 行由 el-table 渲染、拿不到本组件 scope-id，只能 ::v-deep；类名唯一不会波及其他表格 */
::v-deep .reminder-message-row--jump {
    cursor: pointer;
}

/* 操作图标 */
.reminder-message-action-icon {
    font-size: 14px;
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.06);
    transition: background 0.15s, transform 0.1s;
    line-height: 1;

    &:hover {
        background: rgba(0, 0, 0, 0.12);
        transform: scale(1.1);
    }

    &--blue {
        color: #007aff;
    }
}

.reminder-message-read-text {
    font-size: 11px;
    color: #34c759;
    font-weight: 500;
}

/* 空状态 */
.reminder-message-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    color: #86868b;

    i {
        font-size: 48px;
        margin-bottom: 12px;
        opacity: 0.4;
    }

    p {
        font-size: 13px;
    }
}

/* 分页器 */
.reminder-message-pagination {
    padding: 14px 20px;
    border-top: 0.5px solid rgba(0, 0, 0, 0.06);
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
}
</style>
